<template>
  <div>
    <vxe-grid
      auto-resize
      ref="vxeGrid"
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight"
      size="small"
      :loading="loading"
      resizable
      border
      :expand-config="{ reserve: true }"
      :edit-rules="validRules"
      :edit-config="{
        trigger: 'click',
        mode: 'row',
      }"
      @edit-closed="editClosed"
      @edit-actived="editActived"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">{{
              $l('form_label_template_attachment') || '模板附件'
            }}</span>
            <el-divider v-if="!disabled" direction="vertical"></el-divider>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-success"
              v-if="!disabled"
              @click="openDetailDialog({ type: 'add' })"
            >
              <i class="el-icon-plus" />{{
                $l('INDEX.product_dialog_btn_add') || '添加'
              }}
            </b-button>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-danger"
              @click="batchDel()"
              v-if="!disabled"
            >
              <i class="el-icon-delete" />
              {{ $l('INDEX.btn_delete') || '删除' }}
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_downloada') || '下载'"
            placement="top"
          >
            <i class="el-icon-download tool-btn" @click="downloadFile(row)"></i>
          </el-tooltip>
          <el-tooltip
            v-if="!disabled"
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
    <UploadAttachmentDialog
      :multipleDisabled="multipleDisabled"
      :visible="detailDialogParams.visible"
      :title="detailDialogParams.title"
      :templateCode="templateCode"
      @close="() => (detailDialogParams.visible = false)"
      @updateTableData="updateTableData"
      @reload="loadData"
      ref="uploadAttachmentDialog"
    />
  </div>
</template>
<script>
import UploadAttachmentDialog from '../uploadAttachmentDialog/dialog.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { UploadAttachmentDialog },
  props: {
    disabled: { type: Boolean, default: false },
    multipleDisabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    templateCode: { type: String, default: '' },
    templateAttachmentList: { type: Array, default: () => [] },
  },
  mounted() {
    this.loadData()
  },
  watch: {
    templateAttachmentList: {
      handler(val) {
        if (val) {
          this.tableData = val
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      detailDialogParams: {
        visible: false,
        title: '',
        disabled: false,
        code: '',
      },
      tableHeight: 300,
      templateAttachmentName: '',
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      validRules: {
        templateAttachmentName: [
          {
            required: true,
            message: '模版附件名称必须填写',
          },
        ],
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          type: 'seq',
        },
        {
          field: 'checkbox',
          width: 40,
          align: 'center',
          type: 'checkbox',
          visible: !this.disabled,
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          align: 'center',
          width: 90,
          slots: {
            default: 'opt',
          },
        },
        {
          title:
            this.$l('table_label_template_attachment_name') || '模版附件名称',
          field: 'templateAttachmentName',
          minWidth: 200,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          editRender: {
            name: 'input',
            attrs: {
              type: 'String',
              maxlength: 20,
              clearable: true,
              filterable: true,
              disabled: this.disabled,
              placeholder:
                this.$l('tips_please_enter_template_attachment_name') ||
                '请输入模版附件名称',
            },
          },
        },

        {
          title:
            this.$l('table_label_template_attachment_fileName') ||
            '模板附件文件名称',
          field: 'templateAttachmentFileName',
          minWidth: 250,
          headerAlign: 'center',
          align: 'left',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('table_label_template_attachment_fileType') ||
            '模版文件类型',
          field: 'templateAttachmentFileType',
          minWidth: 100,
          headerAlign: 'center',
          align: 'left',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('table_label_template_attachment_fileUrl') ||
            '模板附件文件Url地址',
          field: 'templateAttachmentFileUrl',
          minWidth: 500,
          headerAlign: 'center',
          align: 'left',
          showHeaderOverflow: true,
          showOverflow: true,
        },
      ],
      tableData: [],
    }
  },
  methods: {
    //加载数据
    loadData() {
      if (!this.templateCode) return
      this.loadingOpen()
      this.$api
        .sysInoutTemplateAttachmentListApi({ templateCode: this.templateCode })
        .then((res) => {
          this.loadingClose()
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    //获取表格数据
    async getTableData() {
      const result = await this.validEvent()
      if (!result) return result
      return this.$refs.vxeGrid.getTableData()
    },
    async validEvent() {
      const errMap = await this.$refs.vxeGrid
        .validate(true)
        .then(() => {
          const { tableData } = this.$refs.vxeGrid.getTableData()
          const newArr = tableData.map((item) => item.templateAttachmentName)
          const arrSet = new Set(newArr)
          if (arrSet.size === newArr.length) return false
          this.$message.warning('模板附件名称重复请检查后保存!')
          return true
        })
        .catch((errMap) => errMap)
      if (errMap) {
        return false
      } else {
        return true
      }
    },
    // 更改表格数据
    updateTableData(data) {
      const listAttachment = data.listAttachment
      if (!listAttachment || !listAttachment.length) return
      const tableData = listAttachment.map((i) => {
        return {
          templateAttachmentFileCode: i.templateAttachmentFileCode,
          templateAttachmentFileUrl: i.templateAttachmentFileUrl,
          templateAttachmentFileName: i.templateAttachmentFileName,
          templateAttachmentFileType: i.templateAttachmentFileType,
          templateAttachmentName: data.templateAttachmentName,
        }
      })
      //   .filter(
      //     (i) =>
      //       this.tableData.findIndex(
      //         (j) => j.templateAttachmentName === i.templateAttachmentName
      //       ) < 0
      //   )
      // if (tableData.length !== listAttachment.length) {
      //   this.$message.error('模板附件名称重复, 请修改后重试')
      //   return
      // }
      this.detailDialogParams.visible = false
      this.tableData.push(...tableData)
    },
    // 批量删除
    batchDel() {
      const data = this.getCheckboxRecords()
      if (!data || !data.length) return

      this.$confirm('您确定要删除所勾选数据吗?').then((type) => {
        if (type === 'confirm') {
          if (this.templateCode) {
            const templateAttachmentCodeList = data.map(
              (i) => i.templateAttachmentCode
            )
            this.delAttachment(templateAttachmentCodeList)
          } else {
            this.$refs.vxeGrid.removeCheckboxRow()
          }
        }
      })
    },
    //单行删除
    del(row) {
      if (this.templateCode) {
        this.delAttachment([row.templateAttachmentCode])
      } else {
        let index = this.$refs.vxeGrid.getRowIndex(row)
        this.tableData.splice(index, 1)
      }
    },
    // 删除具体实现
    delAttachment(templateAttachmentCodeList) {
      this.loadingOpen()
      this.$api
        .sysInoutTemplateAttachmentDelApi({
          templateAttachmentCodeList,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
            return
          }
          this.$message({
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.loadData()
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        })
    },
    getCheckboxRecords() {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          message: this.$l('INDEX.tips_select_data') || '请选择需要操作的数据',
          type: 'warning',
        })
        return
      }
      return data
    },
    openDetailDialog({ type, code = '' }) {
      const types = {
        add:
          this.$l('dialog_title_add_template_attachment_information') ||
          '添加模板附件信息',
      }
      this.detailDialogParams = {
        visible: true,
        title: types[type],
        code,
        disabled: type === 'detail',
      }
    },
    downloadFile({ templateAttachmentFileCode = '' }) {
      this.$api.SYS_FILEDOWNLOAD(templateAttachmentFileCode)
    },
    editActived({ row }) {
      this.templateAttachmentName = ''
      this.templateAttachmentName = row.templateAttachmentName
    },
    async editClosed({ row }) {
      // const result = await this.validEvent()
      // if (!result) return
      if (row.templateAttachmentName == this.templateAttachmentName) return

      // const tableData = this.$refs.vxeGrid.getTableData().fullData
      // const sameAttachmentName = tableData.filter(
      //   (j) => j.templateAttachmentName === row.templateAttachmentName
      // )
      // if (sameAttachmentName.length > 1) {
      //   this.$message.error('模板附件名称重复')
      //   row.templateAttachmentName = this.templateAttachmentName
      //   return
      // }
      if (this.templateCode) {
        this.loadingOpen()
        this.$api
          .sysInoutTemplateAttachmentSaveApi({
            templateCode: this.templateCode,
            ...row,
          })
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status !== 200) {
              this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
              return
            }
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success',
            })
            this.$emit('close')
          })
          .catch(() => {
            this.loadingClose()
            row.templateAttachmentName = this.templateAttachmentName
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
a:hover {
  color: #409eff;
  text-decoration: none;
}
.el-upload-list__item .el-icon-folder-opened {
  display: none;
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  opacity: 0.75;
  color: #606266;
}
.el-upload-list__item:hover {
  .el-icon-folder-opened {
    display: inline-block;
  }
}
</style>
